import axios from 'axios';
import router from "../../router";
import {TokenStorage} from "../LocalStorage/TokenStorage";
import {LocalStorage} from "../LocalStorage/LocalStorage";

const baseDomain = process.env.VUE_APP_BACKEND_API;

let headers = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
};

const API = axios.create({
  baseURL: baseDomain,
  headers: headers
})

API
  .interceptors
  .request
  .use(function (config) {
    if (TokenStorage.isAuthenticated()) {
      config.headers['Authorization'] ='Bearer '+TokenStorage.getToken();
    }
    return config;
  })
;

API
  .interceptors
  .response
  .use(null, function (error) {

    //Reset and redirect token since its expired
    if (401 === error.response.status) {
      LocalStorage.clear(),
      router.push({name: 'Login'})
    }
    return Promise.reject(error)
  })
;

export default API

